export const environment = {
    production: true,
    enableAuth: true,
    apiUrl: 'https://preprod.api.deskcenter.mycena.co/',
    appUrl: 'https://preprod.app.deskcenter.mycena.co/',
    partnerApiUrl: 'https://preprod.partner.api.deskcenter.mycena.co/api/',

};